import React, { useState } from "react";
import { Image, Modal, Tooltip } from "antd";
import Profile from "../../assets/Profile_Pic.svg";
// import twitterIcon from "../../assets/SocialMediaPlatforms/twitter.svg";
// import facebookIcon from "../../assets/SocialMediaPlatforms/facebook.svg";
// import linkedinIcon from "../../assets/SocialMediaPlatforms/linkedin.svg";
// import YoutubeIcon from "../../assets/SocialMediaPlatforms/Youtube.svg";
// import instagramIcon from "../../assets/SocialMediaPlatforms/instagram.svg";
// import AppStoreReviews from "../../assets/SocialMediaPlatforms/AppStore.svg";
// import blog from "../../assets/SocialMediaPlatforms/blog.svg";
// import bookingcom from "../../assets/SocialMediaPlatforms/Bookingcom.svg";
// import websiteChatBot from "../../assets/SocialMediaPlatforms/ChatBot.svg";
// import complaintWebsite from "../../assets/SocialMediaPlatforms/complaint-website.svg";
// import discussionForums from "../../assets/SocialMediaPlatforms/DiscussionForums.svg";
// import ecomerceWebsites from "../../assets/SocialMediaPlatforms/E-comerceWebsites.svg";
// import emailIcon from "../../assets/SocialMediaPlatforms/Email.svg";
// import expediacom from "../../assets/SocialMediaPlatforms/Expediacom.svg";
// import gmbIcon from "../../assets/SocialMediaPlatforms/gmb.svg";
// import holidayIQ from "../../assets/SocialMediaPlatforms/HolidayIQ.svg";
// import newsIcon from "../../assets/SocialMediaPlatforms/News.svg";
// import playStore from "../../assets/SocialMediaPlatforms/playstore.svg";
// import teamBHP from "../../assets/SocialMediaPlatforms/TeamBHP.svg";
// import tripAdvisor from "../../assets/SocialMediaPlatforms/TripAdvisor.svg";
// import whatsapp from "../../assets/SocialMediaPlatforms/Whatsapp.svg";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import FollowersBlue from "../../assets/FollowersBlue.svg";
import verified from "../../assets/verified.svg";
import FollowingBlue from "../../assets/deepDive/FollowingBlue.svg";
import commentBlue from "../../assets/deepDive/commentBlue.svg";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import PostCardDetails from "./PostCardDetails";
import { useSelector } from "react-redux";
import { getDynamicChannelIcon } from "../../redux/constants/ChannelIcons";
import config1 from "../../config";
import { getTextDirection, kFormatter } from "../../redux/constants";
import { getTextWithWrapHtml } from "../../redux/constants";

const EngagedCard = ({ data, detailedView }) => {
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [deepLinkModal, setDeepLinkModal] = useState({
    url: null,
    modalShow: false,
  });

  const onExternal = (TicketID, PostBrandID) => {
    setDeepLinkModal({
      url: null,
      modalShow: true,
    });
    let url =
      config1?.config1?.app_id === "10" || config1?.config1?.app_id === 10
        ? "https://preprodcx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "6" || config1?.config1?.app_id === 6
        ? window?.location?.origin?.includes("bbps.locobuzz.com") ||
          window?.location?.ancestorOrigins?.[0]?.includes("bbps.locobuzz.com")
          ? "https://bbps.locobuzz.com/ticketDetail"
          : "https://cx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "4" || config1?.config1?.app_id === 4
        ? window?.location?.origin?.includes("demo.locobuzz.com")
          ? "https://demo.locobuzz.com/ticketDetail"
          : window?.location?.origin?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            ) ||
            window?.location?.ancestorOrigins?.[0]?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            )
          ? "https://locobuzzng-uat-aws.locobuzz.com/ticketDetail"
          : "https://demo.locobuzz.com/ticketDetail"
        : "https://demo.locobuzz.com/ticketDetail";
    // : "https://demo.locobuzz.com/ticketDetail";

    let finalUrl = `${url}/${TicketID}/${PostBrandID}`;
    if (config1?.config1?.app_id === "2") {
      console.log("Deep Link URL =>", finalUrl);
    }
    // window.open(finalUrl);

    setDeepLinkModal({
      url: (
        <iframe
          title="Ticket Details"
          allowfullscreen={true}
          src={finalUrl}
          alt="Ticket Details"
          className="w-100 border-0 border-radius-4"
          style={{ height: "calc(100vh - 6.3rem)", marginTop: "3.7rem" }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      ),
      modalShow: true,
    });
  };
  const handleDeepLinkOk = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handleDeepLinkCancel = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  let textDirection = getTextDirection(data?.Text);
  let textDirectionClass = textDirection === "rtl" ? "text-right-arabic" : "";
  let needToShowScrollableContent =
    (workspace_privileges?.environment === 2 ||
      share_workspace_privileges?.environment === 2) &&
    (data?.PlatformID === 43 || data?.PlatformID === 25);
  return (
    <div className="card cardList border-color mb-2 mr-2 text-left">
      <div className="cardList-head pb-0 p-15 mt-0 card-head text_heading d-flex align-items-top">
        <Image
          src={
            data?.Picture === 0 || data?.Picture === "" || !data?.Picture
              ? Profile
              : data?.Picture
          }
          fallback={Profile}
          preview={false}
          alt="Profile Images"
          className="profileImg ml-1 cursor-pointer"
          style={{ width: "3.5rem" }}
        />

        <div className="w-100 line-height-normal">
          <div
            className="profileName line-height-normal"
            style={{ maxWidth: "calc(100% - 7.5rem)" }}
          >
            {data?.AuthorName}
            {(data?.isVerified || data?.isVerified > 0) && (
              <img
                src={verified}
                alt="verified"
                className="profileImg ml-1"
                style={{ width: "1.5rem" }}
              />
            )}
          </div>

          <div className="screenName">{data?.ScreenName}</div>
        </div>
        <div
          className={`sentimentType ${
            !data?.SentimentType === 0 ? "" : data?.SentimentType?.toLowerCase()
          }`}
        >
          {data?.SentimentType}
        </div>
      </div>
      <div className="card-body p-0">
        {data?.Bio > 0 && (
          <div className="cardList__body-description fontSize-12 pl-15 pb-15 pr-15">
            <div className="text_regular font-weight500 w-100">Bio</div>
            <div className="text_regular break-word w-100">{data?.Bio}</div>
          </div>
        )}
        {data?.PlatformID == 1 ? (
          <div className="p-15 pt-0 d-flex align-items-center">
            <span className="mr-15">
              <img
                src={FollowersBlue}
                className="cardList__footer-label"
                alt="FollowersBlue"
              />
              <Tooltip title={data?.Followers?.toLocaleString()}>
                <span className="cardList__footer-count font-weight600 text-Darkgray">
                  {kFormatter(data?.Followers)}
                </span>
              </Tooltip>
            </span>
            <span className="mr-15">
              <img
                src={FollowingBlue}
                className="cardList__footer-label"
                alt="FollowingBlue"
              />
              <Tooltip title={data?.FollowingCount?.toLocaleString()}>
                <span className="cardList__footer-count font-weight600 text-Darkgray">
                  {kFormatter(data?.FollowingCount)}
                </span>
              </Tooltip>
            </span>
            <span className="d-flex align-items-center">
              <img
                src={
                  data?.PlatformID === 0
                    ? Default_Brand
                    : SocialMedialogo?.[data?.PlatformID]
                    ? SocialMedialogo?.[data?.PlatformID]
                    : Default_Brand
                }
                style={{ maxWidth: "1.5rem" }}
                alt="Channel Icon"
              />
              <Tooltip title={data?.ShareCount?.toLocaleString()}>
                <span className="cardList__footer-count font-weight600 text-Darkgray">
                  {kFormatter(data?.ShareCount)}
                </span>
              </Tooltip>
            </span>
          </div>
        ) : (
          ""
        )}
        <div className="p-15 border-top">
          <div
            className={`${
              data?.TicketID ? "d-flex justify-content-between" : ""
            } ${data?.Text && "mb-15"}`}
          >
            {data?.isReply && (
              <span className="replied_btn">
                <img
                  src={commentBlue}
                  className="cardList__footer-label mr-1"
                  alt="comment"
                />
                {data?.PlatformID === 36 ? "Answered" : "Replied"}
              </span>
            )}
            {data?.isRetweet && (
              <span className="retweet_btn">
                <i className="fa fa-retweet mr-1" />
                Retweeted
              </span>
            )}
            {data?.TicketID ? (
              <div
                className="ticket_details trands cursor-pointer mr-1"
                onClick={() => onExternal(data?.TicketID, data?.BrandID)}
              >
                <Tooltip title="Ticket Details">
                  <span>
                    {" "}
                    {authParams?.theme_type === "1"
                      ? getDynamicChannelIcon("deep_link_icon")
                      : getDynamicChannelIcon("deep_link_icon")}
                  </span>
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="cardList__body-description d-flex fontSize-12">
            <div className="text_regular">
              {data?.PostURL === 0 ? (
                needToShowScrollableContent ? (
                  getTextWithWrapHtml(
                    data?.Text,
                    "",
                    "",
                    textDirectionClass,
                    needToShowScrollableContent
                  )
                ) : (
                  data?.Text
                )
              ) : (
                <a
                  className="break-word d-block"
                  target="_blank"
                  href={data?.PostURL}
                  rel="noreferrer"
                >
                  {needToShowScrollableContent
                    ? getTextWithWrapHtml(
                        data?.Text,
                        "",
                        "",
                        textDirectionClass,
                        needToShowScrollableContent
                      )
                    : data?.Text}
                </a>
              )}
              {!detailedView && data?.Text?.length > 180 && (
                <span
                  className={`blue-text ${
                    personalizationSettingsObj?.isPersonalizationPreviewOpen
                      ? "disabled-cursor"
                      : "cursor-pointer"
                  }`}
                  onClick={() => {
                    setIsModalOpen(true);
                    setIsModalData(data);
                    setIsModalLoader(true);
                  }}
                >
                  ... Read More
                </span>
              )}
            </div>
            {data?.Attachment > 0 && (
              <div className="ml-15" style={{ width: "10rem" }}>
                {data?.MediaType === "photo" ? (
                  <img
                    src={data?.Attachment > 0 && data?.Attachment}
                    alt="Attachment Images"
                    style={{ width: "10rem" }}
                  />
                ) : (
                  <iframe
                    width="100"
                    height="150"
                    style={{ border: "0" }}
                    src={data?.Attachment}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <PostCardDetails
          data={modalData}
          modalData={modalData}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          setIsModalData={setIsModalData}
          isModalLoader={isModalLoader}
          setIsModalLoader={setIsModalLoader}
          type="engagedCard"
        />
      )}
      {deepLinkModal?.modalShow && (
        <Modal
          title={null}
          open={deepLinkModal?.modalShow}
          style={{ width: "100%", top: "1rem", paddingBottom: "1rem" }}
          onOk={handleDeepLinkOk}
          onCancel={handleDeepLinkCancel}
          width="100%"
          footer={null}
          className={`deepLinkModal ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
        >
          {!deepLinkModal?.url ? (
            <div
              className="loader mx-auto"
              style={{ height: "calc(100vh - 2.6rem)" }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            deepLinkModal?.url
          )}
        </Modal>
      )}
    </div>
  );
};

export default EngagedCard;
